import { useTranslation } from "../i18n";
import ManualProductsAdmin from "../components/ManualProductsAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

// Admin › Warehouse › Manual Products (plan: feat-manual-products.md).
// Lists of products without barcodes (uploaded spreadsheets) and the table
// of SKUs printed from SKU Finder › Manual Products, with the same Table /
// PPD / Jobalots exports as Admin › Warehouse › Wipe.
const AdminManualProducts = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="manual_products_settings"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "manual_products_settings" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("manual_products_admin_hint")}</p>
                <ManualProductsAdmin />
            </div>
        </div>
    );
};

export default AdminManualProducts;
